import React from "react";
import { ExternalLink, Navigation } from "lucide-react";

// Keyless Google Maps embed + link (no API key / billing required).
export const mapsSearchUrl = (q) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent((q || "").trim())}`;
export const mapsEmbedUrl = (q) => `https://www.google.com/maps?q=${encodeURIComponent((q || "").trim())}&z=15&output=embed`;
export const mapsDirUrl = (q) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent((q || "").trim())}`;

export default function MapEmbed({ query, height = 180, className = "" }) {
  const q = (query || "").trim();
  if (!q) return null;
  return (
    <div className={className} data-testid="map-embed">
      <div className="overflow-hidden rounded-xl border border-white/10">
        <iframe title="Location map" src={mapsEmbedUrl(q)} width="100%" height={height}
          style={{ border: 0, display: "block" }} loading="lazy" allowFullScreen
          referrerPolicy="no-referrer-when-downgrade" />
      </div>
      <div className="mt-2 flex items-center gap-4 flex-wrap">
        <a href={mapsDirUrl(q)} target="_blank" rel="noreferrer" data-testid="map-directions-link"
          className="inline-flex items-center gap-1.5 rounded-full bg-[#D4AF37] text-black text-sm font-semibold px-4 py-2 active:scale-95 transition-transform">
          <Navigation size={14} /> Get directions
        </a>
        <a href={mapsSearchUrl(q)} target="_blank" rel="noreferrer" data-testid="map-open-link"
          className="inline-flex items-center gap-1.5 text-[#D4AF37] text-sm font-medium active:scale-95 transition-transform">
          <ExternalLink size={14} /> Open in Google Maps
        </a>
      </div>
    </div>
  );
}
